import { getData } from "../../api";

// Blog
export const Event = async () => {
  try {
    return await getData(`/luxury/footer/event`);
  } catch (error) {
    console.log(error);
  }
};

export const NEWS = async () => {
  try {
    return await getData(`/luxury/footer/news`);
  } catch (error) {
    console.log(error);
  }
};

export const Insights = async (page=1,per_page=5) => {
  try {
    return await getData(`/luxury/footer/insights?page=${page}&per_page=${per_page}`);
  } catch (error) {
    console.log(error);
  }
};

export const SingleInsights = async (id) => {
  try {
    return await getData(`/luxury/footer/insights/${id}`);
  } catch (error) {
    console.log(error);
  }
};
